module.exports = __webpack_public_path__ + "img/45.ec7e6600.jpg";